import React from 'react';
import './academicCommoncrd.css'
const AcademicCommoncrd = ({ info, innoProgram, callPartCard, crdHight, XLHight }) => {

    const Cardhd = `
    .academic-card-container{
        height: ${crdHight}px !important;
    }
    @media (max-width: 575px){
        .academic-card-container{
            height: inherit !important;
        }
    }
    @media (min-width: 1400px){
        .academic-card-container{
            height: ${XLHight}px !important;
        }
    }
    `

    return (
        <>
            <style>{Cardhd}</style>

            <div className="col-md-4 academic-info-Card">
                <div className="academic-card-container">
                    <div className="card-text">
                        <h1 >{info.title1 ? info.title1 : ""}</h1>
                        {callPartCard && <p className="body-text">{info.description1 ? info.description1 : ""}</p>}
                        {!innoProgram && <p className=" body-text fw-bold p-0 m-0">{info.title2 ? info.title2 : ""}</p>}
                        {!innoProgram && <p className=" body-text fw-bold p-0 m-0">{info.title3 ? info.title3 : ""}</p>}
                        {!callPartCard && <p className="body-text">{info.description1 ? info.description1 : ""}</p>}
                        {innoProgram && <p className="body-text fw-bold  p-0">{info.title2 ? info.title2 : ""}</p>}
                        {innoProgram && <p className=" body-text  fw-bold p-0">{info.title3 ? info.title3 : ""}</p>}
                        {info?.description2 && <p className="body-text"> <span className="fw-bold pe-1">{info?.description2_title}</span> {info?.description2}</p>}
                        {info?.description3 && <p className="body-text"> <span className="fw-bold pe-1">{info?.description3_title}</span> {info?.description3}</p>}
                        {info?.description4 && <p className="body-text">{info?.description4}</p>}
                        {info?.line_through_date1 && <p className="body-text">{info?.line_through_date1?.slice(0, 24)}
                            <span className="text-decoration-line-through">{info?.line_through_date1?.slice(24, 54)}</span>
                            {info?.line_through_date1?.slice(54, 500)}</p>}
                        {info?.line_through_date2 && <p className="body-text">{info?.line_through_date2?.slice(0, 45)}
                            <span className="text-decoration-line-through">{info?.line_through_date2?.slice(45, 64)}</span>
                            {info?.line_through_date2?.slice(64, 500)}</p>}


                        {info?.description5 && <p className="body-text">{info?.description5}</p>}
                        {info?.description6 && <p className="body-text">{info?.description6}</p>}
                    </div>

                </div>
            </div>
        </>
    );
};

export default AcademicCommoncrd;